import { render, staticRenderFns } from "./batch-upload.vue?vue&type=template&id=77c97aff&scoped=true"
import script from "./batch-upload.vue?vue&type=script&lang=js"
export * from "./batch-upload.vue?vue&type=script&lang=js"
import style0 from "./batch-upload.vue?vue&type=style&index=0&id=77c97aff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c97aff",
  null
  
)

export default component.exports